import { isNil } from 'lodash';

export const checkNumber = (value: number | string | null | undefined): number | null =>
  Number.isNaN(Number(value)) || value === '' || isNil(value) ? null : Number(value);
